import { useSelector } from 'react-redux';
import { isAllowedPriceDiffOverquota, isPriceDifferentiation } from 'reactApp/appHelpers/featuresHelpers/features/priceDifferentiation';
import { BillingPersonalizationSelectors } from 'reactApp/modules/billingPersonalization/billingPersonalization.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { isCloudOrMailOrApiOverQuota } from 'reactApp/modules/userQuota/overquota.helpers';
import {
    getMultiTariffMobileBillingPersonalization,
    getMultiTariffMobilePriceDiff,
    getMultiTariffMobileProductsSpacesListByTab,
    getMultiTariffMobileProductsSpacesListByTabForAnonymous,
} from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/MultiTariffsListMobile.selectors';
import type { RootState } from 'reactApp/store';

export const useGetProductsSpaces = () => {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isOverquota = useSelector(isCloudOrMailOrApiOverQuota);
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const isAnonymous = useSelector(UserSelectors.isAnonymous);

    const isBillingPersonalisationEnabled = useSelector(BillingPersonalizationSelectors.isBillingPersonalisationEnabledMobile);

    return useSelector((state: RootState) => {
        // [CLOUDWEB-20022][Touch] Добавить мультитарифный лендинг на анонимов
        if (isAnonymous) {
            return getMultiTariffMobileProductsSpacesListByTabForAnonymous(state);
        }
        // tempexp_19915-start
        if (isBillingPersonalisationEnabled) {
            return getMultiTariffMobileBillingPersonalization(state);
        }
        // tempexp_19915-end

        // tempexp_19870-start
        if (!isCorpUser && !isPaidUser && isPriceDifferentiation && (!isOverquota || (isAllowedPriceDiffOverquota && isOverquota))) {
            return getMultiTariffMobilePriceDiff(state);
        }
        // tempexp_19870-end

        // !IMPORTANT. Не расширяем оригинальный селектор. Если для эксперимента нужны другие тарифы/цены - заводим отдельный.
        return getMultiTariffMobileProductsSpacesListByTab(state);
    });
};
